import React from 'react';
import {ErrorView} from './ErrorView';
import {useTranslate} from '../../hooks';

export const WrongBrowserError: React.FC = () => {
  const translate = useTranslate();
  return (
    <ErrorView
      title={translate('login.bankid.wrong-browser.title')}
      subtitle={translate('login.bankid.wrong-browser.subtitle')}
    />
  );
};
